module.exports = __webpack_public_path__ + "static/media/meta bikes-header-logo.2740233b.png";